import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ISelectOption } from '../../../../../../../../design/inputs/select/ISelectOption';
import { getAnnotationStatusText } from '../../../../../../../../modules/annotations/getAnnotationStatusText';
import { IImageFilters } from '../../../imageFilters.model';
import { ImageAnnotationStatus } from '../../../projectDetailsImages.model';
import { FiltersDropdownRow } from '../FiltersDropdownRow';

interface IStatusFilterInfoProps {
  imageFilters: IImageFilters;
}

export const StatusFilterInfo = observer((props: IStatusFilterInfoProps): ReactElement => {
  const { t } = useTranslator();

  const imageAnnotationStatusOptions: ISelectOption<ImageAnnotationStatus>[] = [
    ImageAnnotationStatus.NONE,
    ImageAnnotationStatus.CLARIFICATION,
    ImageAnnotationStatus.DRAFT,
    ImageAnnotationStatus.REJECTED,
    ImageAnnotationStatus.TOREVIEW,
    ImageAnnotationStatus.ACCEPTED,
  ].map((x) => ({ value: x, label: t(getAnnotationStatusText(x)) }));

  const selectedOptions = imageAnnotationStatusOptions.filter((d) => props.imageFilters.annotationStatuses.includes(d.value));

  return (
    <FiltersDropdownRow
      label={t('image_filters.status')}
      count={selectedOptions.length}
    >
      <>
        {selectedOptions.map((d) => (
          <div key={d.value}>{d.label}</div>
        ))}
      </>
    </FiltersDropdownRow>
  );
});
